import { Component, type ErrorInfo, type ReactNode } from "react";

interface Props {
  children: ReactNode;
}

interface State {
  error: Error | null;
}

// React error boundary. Catches render-phase exceptions in child
// components, logs them, and shows a graceful fallback with a Reload
// button. The alternative is a whitescreen on any uncaught component
// crash — which is what happens by default in production builds.
export default class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("ErrorBoundary caught:", error, info.componentStack);
  }

  reload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.error) {
      return (
        <main className="page page--error">
          <h1 className="error-boundary__title">Something went wrong.</h1>
          <p className="error-boundary__body">
            The page hit an unexpected error. Try reloading — if it
            keeps happening, let Michael know what you were doing.
          </p>
          <button
            type="button"
            className="error-boundary__button"
            onClick={this.reload}
          >
            Reload
          </button>
        </main>
      );
    }
    return this.props.children;
  }
}
